export default function initTopLoading() {
    // フラグをチェック（sessionStorageなどから取得）
    const skipAnimation = sessionStorage.getItem('loadingAnimationShown') === 'true';

    // GSAPまたはプラグインが読み込まれていない場合は処理を中断（エラー回避）
    if (typeof gsap === 'undefined' || typeof DrawSVGPlugin === 'undefined') {
        console.warn('GSAP or DrawSVGPlugin is not loaded.');
        return;
    }

    const loading = document.querySelector('#js-loading');
    const loadingSvg = document.querySelector('#js-loading-svg');
    const furnitureElement = document.querySelector('#js-loading-furniture');
    const cycleElement = document.querySelector('#js-loading-cycle');
    // js-loading-union-shape, js-loading-equal, js-loading-furnicycleを取得
    const unionShapeElement = document.querySelector('#js-loading-union-shape');
    const equalElement = document.querySelector('#js-loading-equal');
    const furnicycleBelt = document.querySelector('#js-loading-furnicycle-belt')
    const furnicycleElement = document.querySelector('#js-loading-furnicycle');

    function proceedToNext() {
        // 幕を開ける
        loading.classList.add('is-loaded');

        // カスタムイベントを発行
        document.dispatchEvent(new CustomEvent('loadingComplete'));
    }


    // GSAPとDrawSVGPluginを使用してアニメーションを設定
    gsap.registerPlugin(DrawSVGPlugin);

    // アニメーション開始時に瞬時にSVGを表示
    gsap.set([loadingSvg], {
        opacity: 1
    });

    // タイムラインを作成
    const tl = gsap.timeline({
        // 終了時のアクション
        onComplete: () => {
            // アニメーション完了後の処理
            console.log('Loading animation complete');

            // フラグを保存
            sessionStorage.setItem('loadingAnimationShown', 'true');

            // windowのload完了をチェック
            if (document.readyState === 'complete') {
                // すでにload完了している場合
                console.log('Window already loaded');
                proceedToNext();
            } else {
                // まだload完了していない場合は待機
                console.log('Waiting for window load...');
                window.addEventListener('load', proceedToNext, { once: true });
            }

        }
    });

    // furnitureのpathアニメーション
    if (furnitureElement) {
        const paths = furnitureElement.querySelectorAll('path');
        // 各pathにDrawSVGアニメーションを追加
        paths.forEach((path, index) => {
            tl.fromTo(
                path,
                {
                    drawSVG: '0%'
                },
                {
                    drawSVG: '100%',
                    duration: .8,
                    ease: 'power2.inOut'
                },
                index === 0 ? undefined : '<'// すべてのpathを同時に開始
            );
        });
    }

    // = のマスクアニメーション
    if (unionShapeElement) {
        tl.fromTo(
            unionShapeElement,
            {
                opacity: 0,
                // rotate animation
                rotate: -360,
                // transform-originの設定 center
                transformOrigin: '50% 50%',
            },
            {
                opacity: 1,
                rotate: 0,
                duration: .5,
                ease: 'power2.inOut'
            }
        );
    }

    // cycleのpathアニメーション
    if (cycleElement) {
        const cyclePaths = cycleElement.querySelectorAll('path');
        cyclePaths.forEach((path, index) => {
            tl.fromTo(
                path,
                {
                    drawSVG: '0%'
                },
                {
                    drawSVG: '100%',
                    duration: .8,
                    ease: 'power2.inOut'
                },
                index === 0 ? undefined : '<' // 1つ目はfurnitureの後、2つ目以降は1つ目と同時
            );
        });
    }

    // equalのmaskのアニメーション
    if (equalElement) {
        const mask = equalElement.querySelector('#equal-mask')
        console.log(mask)
        tl.fromTo(
            mask,
            {
                // transform-origin left center, scale 0
                transformOrigin: '0% 50%',
                scaleX: 0,
                scaleY: 1,
            },
            {
                scale: 1,
                duration: .5,
                ease: 'power2.inOut'
            }
        );
    }

    // beltのアニメーション
    if (furnicycleBelt && furnicycleElement) {
        const mask = furnicycleElement.querySelector('#furnicycle-mask');

        // mobileとdesktopでベルトのアニメーションを分ける
        // グローバル
        const is_mobile = Boolean(furnicycleData.is_mobile);
        let beltAnimationFirstFrom = null;
        let beltAnimationFirstTo = null;
        let beltAnimationSecondFrom = null;
        let beltAnimationSecondTo = null;
        if (is_mobile) {
            beltAnimationFirstFrom = {
                transformOrigin: '50% 0%',
                scaleX: 1,
                scaleY: 0,
            };
            beltAnimationFirstTo = {
                scaleY: 1,
                duration: .5,
                ease: 'power2.inOut'
            };
            beltAnimationSecondFrom = {
                transformOrigin: '0% 100%',
                scaleX: 1,
                scaleY: 1,
            };
            beltAnimationSecondTo = {
                scaleY: 0,
                duration: .5,
                ease: 'power2.inOut'
            };
        } else {
            beltAnimationFirstFrom = {
                transformOrigin: '0% 50%',
                scaleX: 0,
                scaleY: 1,
            };
            beltAnimationFirstTo = {
                scaleX: 1,
                duration: .5,
                ease: 'power2.inOut'
            };

            beltAnimationSecondFrom = {
                transformOrigin: '100% 50%',
                scaleX: 1,
                scaleY: 1,
            };
            beltAnimationSecondTo = {
                scaleX: 0,
                duration: .5,
                ease: 'power2.inOut'
            }
        }

        tl.fromTo(
            furnicycleBelt,
            beltAnimationFirstFrom,
            beltAnimationFirstTo
        )
            .fromTo(
                mask,
                beltAnimationFirstFrom,
                beltAnimationFirstTo,
                '<' // 同時に開始
            )
            .call(() => {
                // 要素を複製
                const clonedBelt = furnicycleBelt.cloneNode(true);
                clonedBelt.id = 'js-loading-furnicycle-belt-clone';
                furnicycleBelt.parentNode.insertBefore(clonedBelt, furnicycleBelt.nextSibling);

                // 元の要素を非表示
                gsap.set(furnicycleBelt, { opacity: 0 });

                // スキップ時は即座に完了状態を適用
                if (skipAnimation) {
                    gsap.set(clonedBelt, {
                        transformOrigin: '100% 50%',
                        scaleX: 0,
                        scaleY: 1
                    });
                    tl.to({}, { duration: 1 }); // 余韻を追加
                } else {
                    // 複製した要素で新しいアニメーション
                    tl.fromTo(
                        clonedBelt,
                        beltAnimationSecondFrom,
                        beltAnimationSecondTo
                    )
                        .to({}, { duration: 1 }); // 余韻を追加
                }
            });
    }

    // フラグがtrueの場合、アニメーションを即座に完了
    if (skipAnimation) {
        tl.progress(1);
    }

}